var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitEntryIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "recruit_entry_icon8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.525,
    height: 45.92,
    viewBox: "0 0 40.525 45.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184027",
    "data-name": "\\uADF8\\uB8F9 184027",
    transform: "translate(0.632 10.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131800",
    "data-name": "\\uD328\\uC2A4 131800",
    d: "M408.588,231.633l19.837,11.052V219.392L408.588,208.34Z",
    transform: "translate(-407.989 -207.74)",
    fill: "#00ddb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131801",
    "data-name": "\\uD328\\uC2A4 131801",
    d: "M428.716,218.867,408.88,207.816a.6.6,0,0,0-.891.524v23.293a.6.6,0,0,0,.307.525l19.837,11.051a.581.581,0,0,0,.292.076.593.593,0,0,0,.305-.083.6.6,0,0,0,.295-.517V219.392A.6.6,0,0,0,428.716,218.867Zm-.891,22.8-18.636-10.384v-21.92l18.636,10.384Z",
    transform: "translate(-407.989 -207.74)",
    fill: "#111"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184028",
    "data-name": "\\uADF8\\uB8F9 184028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131802",
    "data-name": "\\uD328\\uC2A4 131802",
    d: "M408.588,208.367l19.954,11.072,18.107-10.15L426.7,198.217Z",
    transform: "translate(-407.357 -197.531)",
    fill: "#ffa8d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131803",
    "data-name": "\\uD328\\uC2A4 131803",
    d: "M407.357,208.369l21.185,11.757,19.34-10.838L426.7,197.531Zm38.062.923-16.879,9.46-18.72-10.387L426.7,198.9Z",
    transform: "translate(-407.357 -197.531)",
    fill: "#32303c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184029",
    "data-name": "\\uADF8\\uB8F9 184029",
    transform: "translate(20.837 11.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131804",
    "data-name": "\\uD328\\uC2A4 131804",
    d: "M428.8,242.849l17.854-9.526V209.289L428.8,219.322Z",
    transform: "translate(-428.194 -208.69)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131805",
    "data-name": "\\uD328\\uC2A4 131805",
    d: "M446.357,208.767,428.5,218.8a.6.6,0,0,0-.306.523v23.529a.6.6,0,0,0,.883.528l17.856-9.527a.6.6,0,0,0,.317-.529V209.291a.6.6,0,0,0-.893-.524Zm-.307,24.2-16.656,8.888V219.673l16.656-9.359Z",
    transform: "translate(-428.194 -208.69)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitEntryIcon8);
export default __webpack_public_path__ + "static/media/recruit_entry_icon8.4b5c79c767c1c3177e3a590a35243b14.svg";
export { ForwardRef as ReactComponent };